import React, { useRef } from 'react';
import Share from './share.png';
import './share.css';
import insta from './insta.png';

const ShareButtonComponent = () => {
  const textAreaRef = useRef(null);

  const handleShare = async () => {
    try {
      const urlToCopy = window.location.href;

      if (navigator.share) {
        await navigator.share({
          url: urlToCopy,
        });
      } else {
        textAreaRef.current.value = urlToCopy;
        textAreaRef.current.select();
        document.execCommand('copy');
      }
    } catch (error) {
      console.error('Error sharing:', error);
    }
  };

  return (
    <div className="share-button">
      <div className="feature-child">
        <a href="https://www.instagram.com/_no.offense.but_/" target="_blank">
          <img src={insta} className="insta" alt="Instagram" />
        </a>
      </div>
      <button onClick={handleShare}>
        <img src={Share} alt="Share this article" className="shareimg" />
      </button>
      <textarea
        ref={textAreaRef}
        style={{ position: 'absolute', left: '-9999px' }}
        readOnly
      />
    </div>
  );
};

export default ShareButtonComponent;
